import React, { useRef, useEffect } from "react";
import gsap from "gsap";
import { personalDetails } from "../Details";

/* Hover effect: color only (NO underline) */
const headingHoverClass = `
  transition-colors duration-300
  hover:text-purple-400
`;

function Home() {
  const { name, tagline, img } = personalDetails;
  const h11 = useRef();
  const h12 = useRef();
  const h13 = useRef();
  const myimageref = useRef();

  useEffect(() => {
    const tl = gsap.timeline();
    tl.from(h11.current, {
      x: "-100%",
      delay: 0.8,
      opacity: 0,
      duration: 2,
      ease: "Power3.easeOut",
    })
      .from(h12.current, {
        x: "-100%",
        delay: 0.5,
        opacity: 0,
        duration: 2,
        ease: "Power3.easeOut",
      }, "<")
      .from(h13.current, {
        x: "-100%",
        delay: 0.1,
        opacity: 0,
        duration: 2,
        ease: "Power3.easeOut",
      }, "<")
      .from(myimageref.current, {
        x: "200%",
        delay: 0.5,
        opacity: 0,
        duration: 2,
        ease: "Power3.easeOut",
      }, "<");
  }, []);

  return (
    <main className="container mx-auto max-width section md:flex justify-between items-center pb-24">
      
      {/* TEXT SECTION */}
      <div>
        <h1
          ref={h11}
          className={`text-2xl text-white md:text-4xl xl:text-5xl 
                      xl:leading-tight font-bold ${headingHoverClass}`}
        >
          Hi, 👋 <br />
          My Name is
        </h1>

        {/* Name */}
        <h1
          ref={h12}
          className={`mt-1 text-2xl bg-clip-text bg-gradient text-transparent 
                      md:text-4xl xl:text-5xl xl:leading-tight font-bold
                      ${headingHoverClass}`}
        >
          {name}
        </h1>

        {/* Tagline */}
        <h2
          ref={h13}
          className={`mt-2 text-2xl text-white md:text-4xl xl:text-5xl 
                      xl:leading-tight font-bold ${headingHoverClass}`}
        >
          {tagline}
        </h2>
      </div>

      {/* IMAGE SECTION */}
      <div className="mt-8 md:mt-0 flex justify-center md:justify-end">
        <div
          ref={myimageref}
          className="relative w-56 h-56 md:w-64 md:h-64 rounded-full 
                     border-4 border-purple-500 
                     shadow-lg overflow-hidden"
        >
          <img
            src={img}
            alt="Shagun Dave"
            className="w-full h-full object-cover object-top rounded-full"
          />
        </div>
      </div>
    </main>
  );
}

export default Home;
